export class AgreementDocuments {
  AggrementDocumentId: number;
  CustomerId: number;
  DocumentPath: string;
  Reason: string;
  Status: boolean;
  CreatedOn: Date;
  UpdatedOn: Date;
  DocumentID: string;
  DocumentDate: string;
  DocumentPath2: string;
  Document2CreatedOn: Date;
}
